// グループの並び・名称・接頭辞（サーバー側 PromptVersioning.GROUPS と同期させること）
export const PROMPT_GROUPS = [
    { key: 'empathy', name: '共感メッセージ', verPrefix: 'emp' },
    { key: 'character', name: '最終返答', verPrefix: 'fin' },
    { key: 'report', name: '対話レポート作成', verPrefix: 'rpt' },
];

export const PROMPT_TABS = [
    { key: 'sys', label: 'システムプロンプト' },
    { key: 'user', label: 'ユーザープロンプト' },
];

// 編集中（まだバージョンとして保存していない内容）の擬似的な版番号
export const DRAFT_VERSION = -1;

// 変更メモの最大文字数（サーバー constants.OPS_PROMPT_MESSAGE_MAX_LENGTH と同値）
export const MESSAGE_MAX_LENGTH = 255;

export const groupOf = (groupKey) => PROMPT_GROUPS.find((g) => g.key === groupKey);

// 版番号の表示（グループ接頭辞つき。例: fin_v3）
export const verLabel = (v, groupKey) => {
    if (v === null || v === undefined) return '—';
    const group = groupOf(groupKey);
    return (group ? group.verPrefix + '_' : '') + 'v' + v;
};

// 日時を YYYY/MM/DD HH:mm:ss にする
export const formatDateTimeSlash = (value) => {
    if (!value) return '';
    const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (!m) return String(value);
    return `${m[1]}/${m[2]}/${m[3]} ${m[4]}:${m[5]}:${m[6] || '00'}`;
};

// 現在時刻を YYYY/MM/DD HH:mm:ss にする
export const nowSlash = () => {
    const d = new Date();
    const p = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}/${p(d.getMonth() + 1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
};

/**
 * 履歴パネルの行を作る（新しい順）
 * 未保存の編集があれば「編集中」の行を先頭に置く
 * @param {Array} versions サーバーの版一覧（新しい順）
 * @param {{baseVer:number|null, date:string}|null} draft
 */
export const buildVersionRows = (versions, draft) => {
    const nodes = (draft ? [{
        v: DRAFT_VERSION, parent_v: draft.baseVer ?? null, message: 'まだバージョンとして保存されていません', draft: true, date: draft.date,
        is_deployed: false, is_starred: false,
    }] : []).concat((versions || []).map((v) => ({ ...v, draft: false })));

    return nodes.map((n) => ({
        v: n.v,
        parent: n.parent_v ?? null,
        draft: n.draft,
        message: n.message,
        date: n.draft ? n.date : formatDateTimeSlash(n.regdate),
        isDeployed: !!n.is_deployed,
        isStarred: !!n.is_starred,
    }));
};

// 指定した版のスターだけを書き換えたグループを返す（画面を先に更新するために使う）
export const withStar = (group, v, isStarred) => (group
    ? { ...group, versions: group.versions.map((it) => (it.v === v ? { ...it, is_starred: isStarred } : it)) }
    : group);

// 指定した版の変更メモだけを書き換えたグループを返す
export const withMessage = (group, v, message) => (group
    ? { ...group, versions: group.versions.map((it) => (it.v === v ? { ...it, message } : it)) }
    : group);
